import { cardAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const config = createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = config.definePartsStyle({
  container: {
    borderRadius: 'md',
    _light: { backgroundColor: 'white' },
  },
  body: {
    borderRadius: 'md',
    _light: { backgroundColor: 'white' },
  },
});

const variants = {
  'composition-template': {
    container: {
      background: 'transparent',
    },
    body: {
      backgroundColor: 'transparent',
    },
  },
  dark: {
    container: {
      backgroundColor: 'texas.bg.900',
      _light: { backgroundColor: 'white' },
    },
    body: {
      backgroundColor: 'texas.bg.900',
      _light: { backgroundColor: 'white' },
    },
  },
  brand: {
    container: {
      pos: 'relative',
      overflow: 'hidden',
      minW: '120px',
      maxW: '320px',
      height: '100%',
    },
    body: {
      bg: 'texas.bg.900',
      _hover: { bg: 'texas.bg.800' },
      _light: { _hover: { bg: 'rgba(0, 0, 0, 0.02)' } },
    },
  },
  'hover-shadow': {
    container: {
      _hover: {
        boxShadow: 'dark-lg',
        transition: '200ms ease',
        _light: { boxShadow: 'lg' },
      },
    },
    body: {
      bg: 'gray.700',
      _light: { bg: 'white', border: '1px solid', borderColor: 'gray.100' },
    },
  },
};

export default config.defineMultiStyleConfig({
  baseStyle,
  variants,
});
